var _path, _g, _path2, _g2, _g3, _line, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 216,
    viewBox: "0 0 318 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6005 155.302H201.332C202.089 155.302 202.826 155.22 203.536 155.064C204.247 155.22 204.984 155.302 205.741 155.302H282.159C287.84 155.302 292.446 150.675 292.446 144.967C292.446 139.26 287.84 134.633 282.159 134.633H273.341C267.66 134.633 263.054 130.006 263.054 124.298C263.054 118.591 267.66 113.964 273.341 113.964H301.263C306.945 113.964 311.55 109.337 311.55 103.629C311.55 97.9217 306.945 93.2948 301.263 93.2948H268.933C274.614 93.2948 279.22 88.6679 279.22 82.9603C279.22 77.2527 274.614 72.6258 268.933 72.6258H174.88C180.561 72.6258 185.167 67.9988 185.167 62.2912C185.167 56.5836 180.561 51.9567 174.88 51.9567H91.1138C85.4324 51.9567 80.8267 56.5836 80.8267 62.2912C80.8267 67.9988 85.4324 72.6258 91.1138 72.6258H32.3307C26.6493 72.6258 22.0437 77.2527 22.0437 82.9603C22.0437 88.6679 26.6493 93.2948 32.3307 93.2948H69.0701C74.7515 93.2948 79.3571 97.9217 79.3571 103.629C79.3571 109.337 74.7515 113.964 69.0701 113.964H10.287C4.60566 113.964 0 118.591 0 124.298C0 130.006 4.60566 134.633 10.287 134.633H67.6005C61.9192 134.633 57.3135 139.26 57.3135 144.967C57.3135 150.675 61.9192 155.302 67.6005 155.302ZM307.142 155.302C312.823 155.302 317.429 150.676 317.429 144.968C317.429 139.26 312.823 134.633 307.142 134.633C301.46 134.633 296.854 139.26 296.854 144.968C296.854 150.676 301.46 155.302 307.142 155.302Z",
    fill: "#F3F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1608_21298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5143 85.5589C96.5143 79.9705 98.8524 74.6369 102.962 70.8502L161.913 16.5352C167.361 11.5162 175.775 11.6089 181.111 16.7466L237.34 70.8909C241.255 74.661 243.467 79.8622 243.467 85.2976V162.745C243.467 171.029 236.752 177.745 228.467 177.745H111.514C103.23 177.745 96.5143 171.029 96.5143 162.745V85.5589Z",
    fill: "#75A4FE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1608_21298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 12,
    width: 148,
    height: 166
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5143 85.5589C96.5143 79.9705 98.8524 74.6369 102.962 70.8502L161.913 16.5352C167.361 11.5162 175.775 11.6089 181.111 16.7466L237.34 70.8909C241.255 74.661 243.467 79.8622 243.467 85.2976V162.745C243.467 171.029 236.752 177.745 228.467 177.745H111.514C103.23 177.745 96.5143 171.029 96.5143 162.745V85.5589Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1608_21298)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1608_21298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5143 76.7935L164.127 125.739C167.626 128.272 172.356 128.272 175.855 125.739L243.467 76.7935V167.747C243.467 173.27 238.99 177.747 233.467 177.747H106.514C100.991 177.747 96.5143 173.27 96.5143 167.747V76.7935Z",
    fill: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1608_21298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.127 128.8C167.626 126.267 172.356 126.267 175.855 128.8L243.467 177.746H96.5143L164.127 128.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.917,
    cy: 64.4127,
    rx: 5.40268,
    ry: 5.42762,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.735,
    cy: 64.4127,
    rx: 5.40268,
    ry: 5.42762,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.514 81C161.583 89 176.514 89 187.514 81",
    stroke: "white",
    strokeWidth: 5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1608_21298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.014,
    cy: 170.435,
    rx: 19.5,
    ry: 19.59,
    fill: "#FFCC00"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 237.514,
    y1: 160.891,
    x2: 237.514,
    y2: 172.946,
    stroke: "white",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.514,
    cy: 177.969,
    rx: 2,
    ry: 2.00923,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1608_21298",
    x: 71.5143,
    y: 0.831238,
    width: 196.953,
    height: 214.914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.0769928 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1608_21298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1608_21298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1608_21298",
    x: 79.5143,
    y: 56.7935,
    width: 180.953,
    height: 134.954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1608_21298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1608_21298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1608_21298",
    x: 89.5143,
    y: 116.9,
    width: 160.953,
    height: 64.8454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.252325 0 0 0 0 0.423517 0 0 0 0 0.627631 0 0 0 0.02607 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1608_21298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1608_21298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1608_21298",
    x: 210.514,
    y: 144.845,
    width: 55,
    height: 55.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1608_21298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1608_21298",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerification);
export default __webpack_public_path__ + "static/media/EmailVerification.65011e4dffc6f92e7935e6d259b202ab.svg";
export { ForwardRef as ReactComponent };